import { Instagram, Youtube, Facebook } from 'lucide-react';

// Maslow's social accounts. No Twitter/X (Patrick, 11/1/2026).
// header: true = icon in the site header. Only accounts posting regularly go there;
// everything shows in the footer. YouTube moves to the header once it's active (11/2/2026).
export const SOCIALS = [
  { name: 'Instagram', handle: '@maslow.nyc', url: 'https://www.instagram.com/maslow.nyc', Icon: Instagram, header: true },
  { name: 'YouTube', handle: '@maslownyc', url: 'https://www.youtube.com/@maslownyc', Icon: Youtube, header: false },
  { name: 'Facebook', handle: 'MaslowNYC', url: 'https://www.facebook.com/MaslowNYC', Icon: Facebook, header: false },
];

type Props = { className?: string; iconClassName?: string };

// Icon-only links, for the header.
const SocialLinks = ({ className = '', iconClassName = 'w-5 h-5' }: Props) => (
  <div className={`flex items-center gap-4 ${className}`}>
    {SOCIALS.filter((s) => s.header).map(({ name, url, Icon }) => (
      <a
        key={name}
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`Maslow on ${name}`}
        className="text-maslow-navy hover:text-maslow-gold transition-colors"
      >
        <Icon className={iconClassName} aria-hidden="true" />
      </a>
    ))}
  </div>
);

export default SocialLinks;
